export default "__VITE_ASSET__CeJzJJjA__"